
import {
  GET_SPACES_LIST,
  SET_RESOURCES_LIST,
  SET_COURSES_LIST,
  SET_MY_MACHINE_BOOKINGS_LIST,
  SET_SPACE_DATA,
  SET_CURRENT_RESOURCE,
  SET_FILTER_DATA,
  SET_INTAKE_COMPLETE,
  SET_WORKSHOPS_LIST,
  SET_BOOKING_TYPE,
  SET_CALENDAR_TYPE,
  SET_IS_BOOKING_OPEN,
  SET_IS_WORKSHOP_OPEN,
  SET_MY_WORKSHOP_BOOKINGS_LIST,
  SET_CURRENT_WORKSHOP,
  SET_MEMBERS_LIST,
  SET_CURRENT_MEMBER,
  SET_MEMBER_REPORTS_LIST,
  SET_ALL_MACHINE_BOOKINGS_LIST
} from '../../types/actions/Home.action';
import { AppActions } from '../../types';
import { BOOKING_TYPE, MachineBookingObj, WorkshopBookingObj, WorkshopObj } from 'types/models/home/HomeApp';
import { UserModel } from 'types/models/dataAccess/User';

const initialState: {
  machineBookingsList: WorkshopBookingObj[] | MachineBookingObj[];
  myWorkshopBookingsList: WorkshopBookingObj[];
  resourcesList: any[];
  resource: any;
  currentWorkshop: WorkshopObj | null;
  filterData: any;
  intakeComplete: any;
  workshopsList: WorkshopObj[];
  bookingType: number;
  calendarType: number;
  isBookingOpen: boolean;
  isWorkshopOpen: boolean;
  membersList: UserModel[];
  currentMember: UserModel|null;
  memberReportsList: WorkshopObj[];
  allMachineBookingsList: MachineBookingObj[];
  coursesList: any[];
} = {
  machineBookingsList: [],
  myWorkshopBookingsList: [],
  resourcesList: [],
  resource: {},
  currentWorkshop: null,
  filterData: {},
  intakeComplete: false,
  workshopsList: [],
  bookingType: BOOKING_TYPE.MACHINE,
  calendarType: BOOKING_TYPE.WORKSHOP,
  isBookingOpen: false,
  isWorkshopOpen: false,
  membersList: [],
  currentMember: null,
  memberReportsList: [],
  allMachineBookingsList: [],
  coursesList: []
};

const Home = (state = initialState, action: AppActions) => {
  switch (action.type) {

    case SET_INTAKE_COMPLETE:
      return {
        ...state,
        intakeComplete: action.payload,
      };

    case GET_SPACES_LIST:
      return {
        ...state,
        spacesList: action.payload,
      };

    case SET_SPACE_DATA:
      return {
        ...state,
        currentSpace: action.payload,
      };

    case SET_MY_MACHINE_BOOKINGS_LIST:
      return {
        ...state,
        machineBookingsList: action.payload,
      }

    case SET_WORKSHOPS_LIST:
      return {
        ...state,
        workshopsList: action.payload,
      }

    case SET_RESOURCES_LIST:
      return {
        ...state,
        resourcesList: action.payload,
      }

    case SET_CURRENT_RESOURCE:
      return {
        ...state,
        resource: action.payload,
      }

    case SET_CURRENT_WORKSHOP:
      return {
        ...state,
        currentWorkshop: action.payload,
      }

    case SET_FILTER_DATA:
      return {
        ...state,
        filterData: action.payload,
      }
    case SET_BOOKING_TYPE:
      return {
        ...state,
        bookingType: action.payload,
      };

    case SET_CALENDAR_TYPE:
      return {
        ...state,
        calendarType: action.payload,
      };

    case SET_IS_BOOKING_OPEN:
      return {
        ...state,
        isBookingOpen: action.payload,
      };

    case SET_IS_WORKSHOP_OPEN:
      return {
        ...state,
        isWorkshopOpen: action.payload,
      };

    case SET_MY_WORKSHOP_BOOKINGS_LIST:
      return {
        ...state,
        myWorkshopBookingsList: action.payload,
      }

    case SET_MEMBERS_LIST:
      return {
        ...state,
        membersList: action.payload,
      }

    case SET_CURRENT_MEMBER:
      return {
        ...state,
        currentMember: action.payload,
      }

    case SET_MEMBER_REPORTS_LIST:
      return {
        ...state,
        memberReportsList: action.payload,
      }
    case SET_ALL_MACHINE_BOOKINGS_LIST:
      return {
        ...state,
        allMachineBookingsList: action.payload,
      }

    case SET_COURSES_LIST:
      return {
        ...state,
        coursesList: action.payload,
      }
    default:
      return state;
  }
};
export default Home;
